import { Routes } from '@angular/router';

export const DashboardRoutes: Routes = [
    {
        path: 'dashboard',
        loadComponent: () => import('./pages/index/index.component').then(m => m.IndexComponent),
   
    },
    {
        path: 'requests',
        loadComponent: () => import('./pages/requets/request-listing/request-listing.component').then(m => m.RequestListingComponent),
   
    },
    {
        path: 'requests/detail/:id',
        loadComponent: () => import('./pages/requets/request-details/request-details.component').then(m => m.RequestDetailsComponent),
   
    },
    {
        path: 'user-mangment',
        loadComponent: () => import('./pages/index/index.component').then(m => m.IndexComponent),
   
    },
    {
        path: 'payments',
        loadComponent: () => import('../../../../../abraj-shared/src/lib/components/payment-screen/payment-screen.component').then(m => m.PaymentScreenComponent),

    },
     {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    }
]